"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var _1 = require("./");
var inversify_1 = require("inversify");
var Root = /** @class */ (function () {
    function Root(lookups, ACL, attendee, calendar, event, rsvp) {
        this.lookups = lookups;
        this.ACL = ACL;
        this.attendee = attendee;
        this.calendar = calendar;
        this.event = event;
        this.rsvp = rsvp;
    }
    var _a, _b, _c, _d, _e, _f;
    Root = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.CalendarLookups)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.CalendarACLClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.CalendarEventRsvpAttendeeClient)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.CalendarClient)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.CalendarEventClient)),
        tslib_1.__param(5, inversify_1.inject(_1.TYPES.CalendarEventRsvpClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.CalendarLookups !== "undefined" && _1.CalendarLookups) === "function" ? _a : Object, typeof (_b = typeof _1.CalendarACLClient !== "undefined" && _1.CalendarACLClient) === "function" ? _b : Object, typeof (_c = typeof _1.CalendarEventRsvpAttendeeClient !== "undefined" && _1.CalendarEventRsvpAttendeeClient) === "function" ? _c : Object, typeof (_d = typeof _1.CalendarClient !== "undefined" && _1.CalendarClient) === "function" ? _d : Object, typeof (_e = typeof _1.CalendarEventClient !== "undefined" && _1.CalendarEventClient) === "function" ? _e : Object, typeof (_f = typeof _1.CalendarEventRsvpClient !== "undefined" && _1.CalendarEventRsvpClient) === "function" ? _f : Object])
    ], Root);
    return Root;
}());
exports.Root = Root;
